(function () {
  var existingApi = window.PleiadesSponsoredProducts;
  if (existingApi && existingApi.initialized) {
    if (typeof existingApi.scheduleRefresh === 'function') {
      existingApi.scheduleRefresh();
    }
    return;
  }

  var publicApi = existingApi || {};
  publicApi.initialized = true;
  window.PleiadesSponsoredProducts = publicApi;

  var endpointBase = 'https://intelligence-api.pleiades.solutions/api/sponsored';
  var storeIdsByHost = {
    'astronomy.store': '1',
    'www.astronomy.store': '1',
    'astronomy-store.com': '1',
    'www.astronomy-store.com': '1',
    'svbony.fr': '2',
    'www.svbony.fr': '2'
  };

  function storeId() {
    return storeIdsByHost[window.location.hostname] || document.documentElement.dataset.sponsoredStoreId || null;
  }

  function getSessionId() {
    try {
      var key = 'sponsored_products_session_id';
      var existing = window.sessionStorage.getItem(key);
      if (existing) return existing;
      var next = 'sp_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
      window.sessionStorage.setItem(key, next);
      return next;
    } catch (error) {
      return 'sp_' + Date.now().toString(36);
    }
  }

  function cardKeyFromDataset(dataset) {
    if (dataset.sku) return 'sku:' + dataset.sku.trim().toLowerCase();
    if (dataset.variantId) return 'variant:' + String(dataset.variantId).trim();
    if (dataset.productId) return 'product:' + String(dataset.productId).trim();
    return null;
  }

  function normalizePlacementKeys(placement) {
    var keys = [];
    if (placement.sku) keys.push('sku:' + String(placement.sku).trim().toLowerCase());
    if (placement.shopifyVariantId) keys.push('variant:' + String(placement.shopifyVariantId).trim());
    if (placement.variantId) keys.push('variant:' + String(placement.variantId).trim());
    if (placement.shopifyProductId) keys.push('product:' + String(placement.shopifyProductId).trim());
    if (placement.productId) keys.push('product:' + String(placement.productId).trim());
    return keys;
  }

  function buildEventItem(card) {
    return {
      campaignId: Number(card.dataset.sponsoredCampaignId || 0) || undefined,
      campaignProductId: Number(card.dataset.sponsoredCampaignProductId || 0) || undefined,
      shopifyProductId: card.dataset.productId || undefined,
      shopifyVariantId: card.dataset.variantId || undefined,
      sku: card.dataset.sku || undefined,
      requestId: card.dataset.sponsoredRequestId || undefined,
      surface: card.dataset.sponsoredSurface || undefined,
      collectionId: card.dataset.sponsoredCollectionHandle || undefined,
      rank: Number(card.dataset.sponsoredRank || 0) || undefined,
      naturalRank: Number(card.dataset.sponsoredNaturalRank || 0) || undefined,
      sponsoredRank: Number(card.dataset.sponsoredRank || 0) || undefined
    };
  }

  function postEvent(path, payload) {
    try {
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(endpointBase + path, blob)) return;
      }
      fetch(endpointBase + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true
      }).catch(function () {});
    } catch (error) {}
  }

  function appendSponsoredParams(url, card) {
    try {
      var nextUrl = new URL(url, window.location.origin);
      nextUrl.searchParams.set('sp_campaign_id', card.dataset.sponsoredCampaignId || '');
      nextUrl.searchParams.set('sp_campaign_product_id', card.dataset.sponsoredCampaignProductId || '');
      nextUrl.searchParams.set('sp_request_id', card.dataset.sponsoredRequestId || '');
      nextUrl.searchParams.set('sp_surface', card.dataset.sponsoredSurface || '');
      nextUrl.searchParams.set('sp_rank', card.dataset.sponsoredRank || '');
      nextUrl.searchParams.set('sp_natural_rank', card.dataset.sponsoredNaturalRank || '');
      return nextUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function trackImpressions(container, cards) {
    if (!('IntersectionObserver' in window)) {
      sendImpressions(container, cards);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      var visible = [];
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        var card = entry.target;
        observer.unobserve(card);
        visible.push(card);
      });
      if (visible.length) sendImpressions(container, visible);
    }, { threshold: 0.5 });
    cards.forEach(function (card) { observer.observe(card); });
  }

  function sendImpressions(container, cards) {
    var resolvedStoreId = storeId();
    if (!resolvedStoreId) return;
    var items = cards.filter(function (card) {
      return card.dataset.sponsoredCampaignId && card.dataset.sponsoredImpressionSent !== 'true';
    }).map(function (card) {
      card.dataset.sponsoredImpressionSent = 'true';
      return buildEventItem(card);
    });
    if (!items.length) return;
    postEvent('/events/impressions', {
      storeId: resolvedStoreId,
      sessionId: getSessionId(),
      surface: container.dataset.sponsoredSurface || 'unknown',
      collectionId: container.dataset.sponsoredCollectionHandle || undefined,
      requestId: items[0].requestId,
      items: items
    });
  }

  function installClickTracking(card) {
    if (card.dataset.sponsoredClickTrackingInstalled === 'true') return;
    card.dataset.sponsoredClickTrackingInstalled = 'true';
    card.addEventListener('click', function (event) {
      if (!card.dataset.sponsoredCampaignId) return;
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      postEvent('/events/clicks', {
        storeId: storeId(),
        sessionId: getSessionId(),
        surface: card.dataset.sponsoredSurface || 'unknown',
        collectionId: card.dataset.sponsoredCollectionHandle || undefined,
        requestId: card.dataset.sponsoredRequestId || undefined,
        items: [buildEventItem(card)]
      });
      if (link && link.href) link.href = appendSponsoredParams(link.href, card);
    }, true);
  }

  function sponsoredLimit(container) {
    var limit = Number(container.dataset.sponsoredLimit || 4);
    if (!Number.isFinite(limit) || limit < 0) return 0;
    return Math.floor(limit);
  }

  function placementSignature(container, cards) {
    return [
      container.dataset.sponsoredSurface || 'unknown',
      container.dataset.sponsoredCollectionHandle || '',
      container.dataset.sponsoredSectionId || '',
      sponsoredLimit(container),
      cards.map(function (card) { return cardKeyFromDataset(card.dataset) || ''; }).join(',')
    ].join('|');
  }

  async function refreshContainer(container) {
    var resolvedStoreId = storeId();
    if (!resolvedStoreId || !container || !container.isConnected) return;
    var cards = Array.from(container.querySelectorAll('[data-sponsored-product-card]'));
    if (!cards.length) return;
    var eligibleCards = cards.slice(0, sponsoredLimit(container));
    if (!eligibleCards.length) return;
    var signature = placementSignature(container, eligibleCards);
    if (
      container.dataset.sponsoredResolvedSignature === signature ||
      container.dataset.sponsoredPendingSignature === signature
    ) return;

    container.dataset.sponsoredLoading = 'true';
    container.dataset.sponsoredPendingSignature = signature;
    try {
      var response = await fetch(endpointBase + '/placements', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          storeId: resolvedStoreId,
          surface: container.dataset.sponsoredSurface || 'unknown',
          collectionHandle: container.dataset.sponsoredCollectionHandle || undefined,
          sectionId: container.dataset.sponsoredSectionId || undefined,
          sectionTitle: container.dataset.sponsoredSectionTitle || undefined,
          limit: Number(container.dataset.sponsoredLimit || 4),
          items: eligibleCards.map(function (card, index) {
            return {
              shopifyProductId: card.dataset.productId,
              shopifyVariantId: card.dataset.variantId,
              sku: card.dataset.sku,
              rank: index + 1
            };
          })
        })
      });
      if (!response.ok) return;
      var payload = await response.json();
      var sponsoredByKey = new Map();
      (payload.placements || []).forEach(function (placement) {
        normalizePlacementKeys(placement).forEach(function (key) {
          sponsoredByKey.set(key, placement.sponsored);
        });
      });

      var sponsoredCards = [];
      eligibleCards.forEach(function (card, index) {
        var key = cardKeyFromDataset(card.dataset);
        var sponsored = key ? sponsoredByKey.get(key) : null;
        delete card.dataset.sponsoredCampaignId;
        delete card.dataset.sponsoredCampaignProductId;
        delete card.dataset.sponsoredRequestId;
        if (!sponsored || !sponsored.isSponsored) return;
        card.dataset.sponsoredCampaignId = String(sponsored.campaignId);
        card.dataset.sponsoredCampaignProductId = String(sponsored.campaignProductId);
        card.dataset.sponsoredRequestId = sponsored.requestId || payload.requestId || '';
        card.dataset.sponsoredSurface = sponsored.surface || container.dataset.sponsoredSurface || 'unknown';
        card.dataset.sponsoredCollectionHandle = container.dataset.sponsoredCollectionHandle || '';
        card.dataset.sponsoredNaturalRank = String(sponsored.naturalRank || index + 1);
        card.dataset.sponsoredRank = String(sponsored.rank || sponsored.sponsoredRank || index + 1);
        installClickTracking(card);
        sponsoredCards.push(card);
      });
      trackImpressions(container, sponsoredCards);
      container.dataset.sponsoredResolvedSignature = signature;
    } catch (error) {
      console.warn('[SponsoredProducts] placements unavailable', error);
    } finally {
      container.dataset.sponsoredLoading = 'false';
      if (container.dataset.sponsoredPendingSignature === signature) {
        delete container.dataset.sponsoredPendingSignature;
      }
    }
  }

  function trackProductViewFromParams() {
    var resolvedStoreId = storeId();
    if (!resolvedStoreId) return;
    var params = new URLSearchParams(window.location.search);
    var campaignId = Number(params.get('sp_campaign_id') || 0);
    var campaignProductId = Number(params.get('sp_campaign_product_id') || 0);
    if (!campaignId || !campaignProductId) return;
    postEvent('/events/product-views', {
      storeId: resolvedStoreId,
      sessionId: getSessionId(),
      surface: params.get('sp_surface') || 'product',
      requestId: params.get('sp_request_id') || undefined,
      items: [{
        campaignId: campaignId,
        campaignProductId: campaignProductId,
        requestId: params.get('sp_request_id') || undefined,
        surface: params.get('sp_surface') || 'product',
        rank: Number(params.get('sp_rank') || 0) || undefined,
        naturalRank: Number(params.get('sp_natural_rank') || 0) || undefined,
        sponsoredRank: Number(params.get('sp_rank') || 0) || undefined
      }]
    });
  }

  function refreshAll() {
    document.querySelectorAll('[data-sponsored-surface]').forEach(refreshContainer);
  }

  var debounceTimer = null;
  function scheduleRefresh() {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(refreshAll, 120);
  }
  publicApi.scheduleRefresh = scheduleRefresh;
  publicApi.refresh = refreshAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      trackProductViewFromParams();
      refreshAll();
    }, { once: true });
  } else {
    trackProductViewFromParams();
    refreshAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event && event.target;
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      scheduleRefresh();
      return;
    }
    if (sectionRoot.matches && sectionRoot.matches('[data-sponsored-surface]')) {
      refreshContainer(sectionRoot);
    }
    sectionRoot.querySelectorAll('[data-sponsored-surface]').forEach(refreshContainer);
  });

  if (document.body && 'MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      var hasSponsoredChanges = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes || []).some(function (node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches('[data-sponsored-surface], [data-sponsored-product-card]')) return true;
          return Boolean(node.querySelector('[data-sponsored-surface], [data-sponsored-product-card]'));
        });
      });
      if (hasSponsoredChanges) scheduleRefresh();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
